var React = require('react');
var ReactDOM = require('react-dom');
var MicroEvent = require('./microevent');
import PropTypes from 'prop-types'
var createReactClass = require('create-react-class');

var TIMEOUT = 15000;

var _state = {
  id: null,
  children: [],
  liveblog: {
    "title": "",
    "extra_title": "",
    "description": "",
    "header_image_caption": "",
    "header_image_credit": "",
    "header_image_search_url": "",
    "latest_revision_timestamp": ""
  },
  timeout: null
};

function _fetchData(id) {
  clearTimeout(_state.timeout);
  console.log("fetching data");

  const onError = function(error) {
    _state.timeout = setTimeout(function() { _fetchData(id);}, TIMEOUT);
  }

  $.getJSON('/api/v2/pages/?type=liveblog.LiveBlogPage&id=' + id + '&fields=id,latest_revision_timestamp&limit=1000')
    .done(function(timestamp_check_liveblog) {

      if (_state.liveblog.latest_revision_timestamp === timestamp_check_liveblog.items[0].latest_revision_timestamp) {
        console.log("NO CHANGE, returning");
        _state.timeout = setTimeout(function() { _fetchData(id);}, TIMEOUT);
        return;
      }

      $.getJSON('/api/v2/pages/' + id + '/')
        .done(function(liveblog) {
          $.getJSON('/api/v2/pages/?child_of=' + id + '&fields=title,slug,body,latest_revision_created_at,first_published_at,key_event,rich_body&type=liveblog.LiveBlogItemPage&order=-first_published_at&limit=1000')
          .done(function(data) {
              _state.liveblog = liveblog;
              _state.children = data.items;
              LiveBlogStore.trigger('change');
              _state.timeout = setTimeout(function(){ _fetchData(id);}, TIMEOUT);
          }).fail(onError);
      }).fail(onError);
  }).fail(onError);


}

var LiveBlogStore = {
    getState: function() {
        return _state;
    },
    setID: function(id) {
      _state.id = id;
      _fetchData(id);
    }
};

MicroEvent.mixin(LiveBlogStore);


var LiveBlogItem = createReactClass({

  propTypes: {
    data: PropTypes.object.isRequired,
    isAdspot: PropTypes.bool
  },

  getInitialState: function() {
      return {
        text: moment(this.props.data.first_published_at).fromNow()
      };
  },

  getDefaultProps: function() {
    return {
      isAdspot: false
    };
  },

  shouldComponentUpdate: function(nextProps, nextState) {
    if (this.state.text !== nextState.text) {
      console.log("Update timer for item " + this.props.data.id);
      return true;
    }
    if(nextProps.data.latest_revision_created_at === this.props.data.latest_revision_created_at) {
      return false;
    } else {
      console.log("WILL UPDATE ITEM " + this.props.data.id);
      return true;
    }
  },

  componentWillMount: function() {
    this._updateMomentText();
    this.interval = setInterval(this._updateMomentText, 60000);
  },

  componentWillUnmount: function() {
    clearInterval(this.interval);
  },

  _updateMomentText: function() {
    var text = moment(this.props.data.first_published_at).fromNow();
    if(text !== this.state.text) {
        this.setState({text: text});
    }
  },

  componentDidMount: function() {
    // We have to add dynamic html which may contain embed code and script tags after react has rendered...
    $(ReactDOM.findDOMNode(this.refs.htmlcontent)).html(this.props.data.rich_body);
  },

  componentDidUpdate: function(prevProps, prevState) {
    $(ReactDOM.findDOMNode(this.refs.htmlcontent)).html(this.props.data.rich_body);
  },

  render: function() {
    var item = this.props.data;
    return (
      <div className="newsitem">
        <span class="anchor" id={item.meta.slug}></span>
        <div className="time">
        <i className="fa fa-clock-o"></i> <span>{moment(this.props.data.meta.first_published_at).format('HH:mm')}</span></div>
          <h2>{item.title}</h2>
        <div ref="htmlcontent"></div>
      </div>
    );
  }

});


function Caption(props) {
  return <div className="main-caption">{props.text}</div>;
}

function Credit(props) {
  return <div className="main-credit"><i className="fa fa-camera-retro"></i> {props.text}</div>;
}


var LiveBlog = createReactClass({

  propTypes: {
    id: PropTypes.number.isRequired
  },

  getInitialState: function() {
    return LiveBlogStore.getState();
  },

  _onChange: function(){
    console.log('change in store, new state:');
    this.setState(LiveBlogStore.getState());
  },

  componentWillUnmount: function(){
      LiveBlogStore.unbind('change', this._onChange);
  },


  componentDidMount: function() {
    LiveBlogStore.bind('change', this._onChange);
    LiveBlogStore.setID(this.props.id);
  },

  renderCaption: function() {
    if(this.state.liveblog.header_image_caption !== "" && this.state.liveblog.header_image_caption !== null) {
      return <Caption text={this.state.liveblog.header_image_caption} />;
    }
  },

  renderCredit: function() {
    if(this.state.liveblog.header_image_credit !== "" && this.state.liveblog.header_image_credit !== null) {
      return <Credit text={this.state.liveblog.header_image_credit} />;
    }
  },

  renderAuthor: function() {
    var liveblog = this.state.liveblog,
        img = "",
        author = "";

    if (liveblog.author_name_override) {
      author = <span className="author">{liveblog.author_name_override}</span>;
    } else {
      author = <a href={'/author/'+liveblog.author_slug}><span className="author">{liveblog.author_title}</span></a>
      if (liveblog.author_image_url) {
        img = <img className="round img-circle" src={liveblog.author_image_url} />;
      }
    }
    if (liveblog.author_image_override_url) {
      img = <img className="round img-circle" src={liveblog.author_image_override_url} />;
    }

    var script = "<script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');</script>";

    return (
      <div className="info clearfix">
          {img}
      </div>
    );
  },

  render: function() {

    var liveblogItems = this.state.children.map(function(item){
      return <LiveBlogItem key={item.id} data={item} />;
    });

    return (
      <div data-liveblog-id={this.props.id}>
        <div className="description"dangerouslySetInnerHTML={{__html:this.state.liveblog.description}} ></div>
        <div className="article-header">
            <img src={this.state.liveblog.header_image_search_url} />
            <div className="caption-container">
                <div className="caption">
                  {this.renderCaption()}
                  {this.renderCredit()}
                </div>
            </div>
        </div>

        {this.renderAuthor()}

        {liveblogItems}
      </div>
    );
  },


});


var LiveBlogKeyEvents = createReactClass({

  propTypes: {
    id: PropTypes.number.isRequired
  },

  getInitialState: function() {
    return LiveBlogStore.getState();
  },

  _onChange: function(){
    console.log('change in store, new state:');
    this.setState(LiveBlogStore.getState());
  },

  componentWillUnmount: function(){
      LiveBlogStore.unbind('change', this._onChange);
  },

  componentDidMount: function() {
    LiveBlogStore.bind('change', this._onChange);
  },

  render: function() {

    var liveblogItems = this.state.children.filter(function(d){return d.key_event === true;}).map(function(item){
      return <li key={"key-event-"+item.id}>
              <div className="time"><i className="fa fa-clock-o"></i> <span>{moment(item.meta.first_published_at).format('D. MMMM  YYYY [kl.] H:mm')}</span></div>
              <a href={"#"+item.meta.slug}><h4>{item.title}</h4></a>
          </li>;
    });

    return (
      <ul className="headlines">
        {liveblogItems}
      </ul>
    );
  },


});



ReactDOM.render(
  <LiveBlog id={LIVEBLOG_ID} />,
  document.getElementById('liveblog')
);

ReactDOM.render(
  <LiveBlogKeyEvents id={LIVEBLOG_ID} />,
  document.getElementById('liveblog-key-events')
);